// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"160":"5ce41bb8","515":"a5decb25","619":"cac2088e","803":"2232e8b6"}[chunkId] + ".css";
};